import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20596d4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rfp-wrapper" }
const _hoisted_2 = { class: "m-0 text-gray-600 dark:text-gray-400 text-sm" }
const _hoisted_3 = { class: "italic mr-2" }
const _hoisted_4 = ["data-tooltip"]
const _hoisted_5 = {
  key: 0,
  class: "m-0 text-gray-600 dark:text-gray-400 text-sm"
}
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = { class: "messages" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-blue-700 font-bold dark:text-blue-300" }, "Rapport", -1))
const _hoisted_10 = { class: "mb-0 font-bold" }
const _hoisted_11 = { class: "m-0 text-gray-600 dark:text-gray-400 text-sm" }
const _hoisted_12 = { class: "italic mr-2" }
const _hoisted_13 = ["data-tooltip"]
const _hoisted_14 = {
  key: 0,
  class: "m-0 text-gray-600 dark:text-gray-400 text-sm"
}
const _hoisted_15 = ["data-tooltip"]
const _hoisted_16 = { class: "actions flex justify-end gap-2" }
const _hoisted_17 = { class: "people" }
const _hoisted_18 = {
  key: 0,
  class: "label-sm mb-4"
}
const _hoisted_19 = { class: "label-sm" }
const _hoisted_20 = { class: "label-sm" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "flex gap-2 buttons" }

import Card from "@/Components/General/Card.vue";
import RfpDescription from "@/Components/Rfp/RfpDescription.vue";
import RfpMeasures from "@/Components/Rfp/RfpMeasures.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import Rfp from "@/types/Rfp/Rfp";
import { computed, ref } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";
import RfpPeople from "@/Components/Rfp/RfpPeople.vue";
import RfpOccuredAt from "@/Components/Rfp/RfpOccuredAt.vue";
import User from "@/types/User";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import RfpCategories from "@/Components/Rfp/RfpCategories.vue";
import RfpCategory from "@/types/Rfp/RfpCategory";
import RfpDeadline from "@/Components/Rfp/RfpDeadline.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import route from "ziggy-js";
import Button from "@/Components/Buttons/Button.vue";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import Messages from "@/Components/General/Messages.vue";
import LogEntry from "@/Components/General/LogEntry.vue";
import { ModeType } from "@/types/ModeType";


export default /*#__PURE__*/_defineComponent({
  ...{
  layout: AppLayout,
},
  __name: 'Show',
  props: {
    rfp: {},
    allCategories: {},
    users: {}
  },
  setup(__props: any) {

const props = __props;

dayjs.extend(calendar);





const mode = ref<ModeType>("view");

const fieldLabels: Record<string, string> = {
  title: "Tittel",
  occured_at: "Dato for hendelse",
  deadline: "Må behandles og lukkes innen",
  description: "Beskrivelse",
  measures: "Forslag til tiltak",
  measures_taken: "Tiltak som ble utført",
  closed_at: "Lukket",
};

const form = useForm({
  title: props.rfp.title,
  occured_at: dayjs(props.rfp.occured_at).format("YYYY-MM-DD"),
  deadline: props.rfp.deadline ? dayjs(props.rfp.deadline).format("YYYY-MM-DD") : null,
  description: props.rfp.description ?? "",
  measures: props.rfp.measures ?? "",
  measures_taken: props.rfp.measures_taken ?? "",
  assigned_ids:
    props.rfp.assigned?.map((user) => {
      return user.id;
    }) ?? [],
  participant_ids:
    props.rfp.participants?.map((user) => {
      return user.id;
    }) ?? [],
  category_ids: props.rfp.categories.map((category) => category.id),
  close: false
});

const isClosed = computed(() => {
  return props.rfp.closed_at !== null;
});

const created_at_formatted = computed(() => {
  return dayjs(props.rfp.created_at).format("DD.MM.YYYY HH:mm");
});

const created_at_relative = computed(() => {
  return dayjs(props.rfp.created_at).calendar();
});

const closed_at_formatted = computed(() => {
  return dayjs(props.rfp.closed_at).format("DD.MM.YYYY HH:mm");
});

const closed_at_relative = computed(() => {
  return dayjs(props.rfp.closed_at).calendar();
});

const send = (close: boolean = false) => {
  form.close = close;

  form.put(route("rfp.update", { rfp: props.rfp.id }), {
    preserveScroll: true,
    onSuccess: (page) => {
      mode.value = "view";
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mode.value === 'log')
      ? (_openBlock(), _createBlock(LogEntry, {
          key: 0,
          type: "Rapport",
          title: `${_ctx.rfp.title} (${_ctx.rfp.id})`,
          activities: _ctx.rfp.activities,
          labels: fieldLabels,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (mode.value = 'view'))
        }, {
          featured_text: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(" Opprettet av "),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.rfp.created_by.firstname + " " + _ctx.rfp.created_by.lastname + " "), 1),
              _createElementVNode("span", {
                class: "tooltip tooltip--indicated",
                "data-tooltip": created_at_formatted.value
              }, _toDisplayString(created_at_relative.value), 9, _hoisted_4)
            ]),
            (_ctx.rfp.closed_at !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createTextVNode(" Ble lukket "),
                  _createElementVNode("span", {
                    class: "tooltip tooltip--indicated",
                    "data-tooltip": closed_at_formatted.value
                  }, _toDisplayString(closed_at_relative.value), 9, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "activities"]))
      : (_openBlock(), _createBlock(Card, {
          key: 1,
          class: "p-8 rfp-show"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(Messages),
              _createVNode(ValidationFormErrors, {
                class: "my-2",
                errors: _unref(form).errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.rfp.title) + " (" + _toDisplayString(_ctx.rfp.id) + ") ", 1),
              _createElementVNode("p", _hoisted_11, [
                _createTextVNode(" Opprettet av "),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.rfp.created_by.firstname + " " + _ctx.rfp.created_by.lastname + " "), 1),
                _createElementVNode("span", {
                  class: "tooltip tooltip--indicated",
                  "data-tooltip": created_at_formatted.value
                }, _toDisplayString(created_at_relative.value), 9, _hoisted_13)
              ]),
              (_ctx.rfp.closed_at !== null)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                    _createTextVNode(" Ble lukket "),
                    _createElementVNode("span", {
                      class: "tooltip tooltip--indicated",
                      "data-tooltip": closed_at_formatted.value
                    }, _toDisplayString(closed_at_relative.value), 9, _hoisted_15)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (mode.value === 'view')
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    color: "info",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (mode.value = 'log'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Logg")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (mode.value === 'view')
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    color: "gray",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (mode.value = 'edit'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Rediger")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (mode.value === 'edit')
                ? (_openBlock(), _createBlock(Button, {
                    key: 2,
                    color: "red",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (mode.value = 'view'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Avbryt")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.rfp.categories?.length > 0 || mode.value === 'edit')
                ? (_openBlock(), _createElementBlock("label", _hoisted_18, [
                    _createTextVNode(" Kategori" + _toDisplayString(_ctx.rfp.categories.length > 1 || mode.value === "edit" ? "er" : "") + " ", 1),
                    _createVNode(RfpCategories, {
                      "all-categories": _ctx.allCategories,
                      "shown-categories": _ctx.rfp.categories,
                      mode: mode.value,
                      modelValue: _unref(form).category_ids,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).category_ids) = $event))
                    }, null, 8, ["all-categories", "shown-categories", "mode", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_19, [
                _createTextVNode(" Deltakere "),
                _createVNode(RfpPeople, {
                  shownUsers: _ctx.rfp.participants,
                  modelValue: _unref(form).participant_ids,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).participant_ids) = $event)),
                  allUsers: _ctx.users,
                  mode: 'edit'
                }, null, 8, ["shownUsers", "modelValue", "allUsers"])
              ]),
              _createElementVNode("label", _hoisted_20, [
                _createTextVNode("Tildelt "),
                (_ctx.rfp.assigned?.length == 0 && mode.value == 'view')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Ingen tildelte"))
                  : _createCommentVNode("", true),
                _createVNode(RfpPeople, {
                  shownUsers: _ctx.rfp.assigned,
                  modelValue: _unref(form).assigned_ids,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).assigned_ids) = $event)),
                  allUsers: _ctx.users,
                  mode: mode.value
                }, null, 8, ["shownUsers", "modelValue", "allUsers", "mode"])
              ])
            ]),
            _createVNode(RfpOccuredAt, {
              class: "occured",
              mode: mode.value,
              modelValue: _unref(form).occured_at,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).occured_at) = $event)),
              error: _unref(form).errors.occured_at
            }, null, 8, ["mode", "modelValue", "error"]),
            _createVNode(RfpDeadline, {
              class: "deadline",
              mode: mode.value,
              modelValue: _unref(form).deadline,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).deadline) = $event)),
              error: _unref(form).errors.deadline
            }, null, 8, ["mode", "modelValue", "error"]),
            _createVNode(RfpDescription, {
              class: "description",
              mode: mode.value,
              modelValue: _unref(form).description,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).description) = $event)),
              error: _unref(form).errors.description
            }, null, 8, ["mode", "modelValue", "error"]),
            _createVNode(RfpMeasures, {
              class: "measures measures-proposed",
              mode: isClosed.value && mode.value === 'view' ? 'view' : 'edit',
              title: "Forslag til tiltak",
              modelValue: _unref(form).measures,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).measures) = $event)),
              error: _unref(form).errors.measures
            }, null, 8, ["mode", "modelValue", "error"]),
            _createVNode(RfpMeasures, {
              class: "measures measures-taken",
              mode: isClosed.value && mode.value === 'view' ? 'view' : 'edit',
              modelValue: _unref(form).measures_taken,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).measures_taken) = $event)),
              title: "Tiltak som ble utført",
              error: _unref(form).errors.measures_taken
            }, null, 8, ["mode", "modelValue", "error"]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.rfp.closed_at === null)
                ? (_openBlock(), _createBlock(HcButton, {
                    key: 0,
                    color: "red",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (send(true))),
                    onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (send(true)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      (_unref(form).close && _unref(form).processing)
                        ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                            key: 0,
                            class: "animate-spin mr-2",
                            type: "mdi",
                            path: _unref(mdiLoading)
                          }, null, 8, ["path"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Lukk rapport ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (mode.value === 'edit' || _unref(form).isDirty)
                ? (_openBlock(), _createBlock(HcButton, {
                    key: 1,
                    color: "green",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (send(false))),
                    onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (send(false)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      (!_unref(form).close && _unref(form).processing)
                        ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                            key: 0,
                            class: "animate-spin mr-2",
                            type: "mdi",
                            path: _unref(mdiLoading)
                          }, null, 8, ["path"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Lagre endringer ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
  ]))
}
}

})